import { Button, Modal } from "antd";
import DatatableAntd from "components/datatable-antd";
import styled from "styled-components";

import useModal from "../../../hooks/useModalGestaoJustificativa";
import column from "./column";
import { formatDateBR } from "../../FiltroAcompanhamentoOperacional/utils";
import { MOTIVOS } from "../../ModalPlanejamentoOperacoes/utils";

interface ModalHistoricoOperacaoProps {
  refetch?: () => void;
  permission: boolean[];
}

function ModalViewTalhaoJustificativa({ permission }: ModalHistoricoOperacaoProps) {
    const { 
    talhaoJustificado,
    isOpenView,
    setIsOpenView,
    setId
  } = useModal();

  function closedModal() {
    setIsOpenView(false);
    setId('');
  }

  const approveN1 = talhaoJustificado?.status === 'Aprovado N1' || talhaoJustificado?.justificativaAtrasoAceiteGerenteUnidadeUsuario ? talhaoJustificado?.justificativaAtrasoAceiteGerenteUnidadeUsuario : "Pendente";
  const approveN2 = talhaoJustificado?.status === 'Aprovado N2' ? talhaoJustificado?.justificativaAtrasoAceiteGerenteRegionalUsuario : 
  talhaoJustificado?.justificativaAtrasoAceiteGerenteUnidadeUsuario ? "Pendente" : "Aguardando aprovação N1";

  const INFO_TABLE = [
    { name: "Período de Produção", value: talhaoJustificado?.safraPeriodo },
    { name: "Área (ha)", value: talhaoJustificado?.talhaoArea },
    { name: "Dias em Atraso", value: talhaoJustificado?.diasEmAtraso },
    { name: "Usuário que registrou", value: talhaoJustificado?.justificativaAtrasoUsuario },
    { name: "Aprovado por (Nível 1)", value: permission[0] || permission[2] ? approveN1 : " - " },
    { name: "Aprovado por (Nível 2)", value: permission[1] || permission[2] ? approveN2 : " - " },
  ]
  const listTableJustificativa: any[] = [];

  if (talhaoJustificado?.status === 'Pendente N1') {
    listTableJustificativa.push({ tipoAtraso: MOTIVOS[talhaoJustificado?.justificativaAtrasoMotivo.toLowerCase() as keyof typeof MOTIVOS], justificativa: talhaoJustificado?.justificativaAtrasoObservacao, data: talhaoJustificado?.justificativaAtrasoDataAtualizacao, aprovado: talhaoJustificado?.status });
  }

  if (talhaoJustificado?.status === 'Aprovado N1' || talhaoJustificado?.status === 'Pendente N2') {
    listTableJustificativa.push(
      { tipoAtraso: MOTIVOS[talhaoJustificado?.justificativaAtrasoMotivo.toLowerCase() as keyof typeof MOTIVOS], justificativa: talhaoJustificado?.justificativaAtrasoObservacao, data: talhaoJustificado?.justificativaAtrasoDataAtualizacao, aprovado: "Pendente N1" },
      { tipoAtraso: MOTIVOS[talhaoJustificado?.justificativaAtrasoMotivoAceiteGerenteUnidade?.toLocaleLowerCase() as keyof typeof MOTIVOS], justificativa: talhaoJustificado?.justificativaAtrasoObservacaoAceiteGerenteUnidade, data: talhaoJustificado?.justificativaAtrasoDataAceiteGerenteUnidade, aprovado: "Aprovado N1" },
    );
  }

  if (talhaoJustificado?.status === 'Aprovado N2') {
    listTableJustificativa.push(
      { tipoAtraso: MOTIVOS[talhaoJustificado?.justificativaAtrasoMotivo?.toLocaleLowerCase() as keyof typeof MOTIVOS], justificativa: talhaoJustificado?.justificativaAtrasoObservacao, data: talhaoJustificado?.justificativaAtrasoDataAtualizacao, aprovado: "Pendente N1" },
      { tipoAtraso: MOTIVOS[talhaoJustificado?.justificativaAtrasoMotivoAceiteGerenteUnidade?.toLocaleLowerCase() as keyof typeof MOTIVOS], justificativa: talhaoJustificado?.justificativaAtrasoObservacaoAceiteGerenteUnidade, data: talhaoJustificado?.justificativaAtrasoDataAceiteGerenteUnidade, aprovado: "Aprovado N1" },
      { tipoAtraso: MOTIVOS[talhaoJustificado?.justificativaAtrasoMotivoAceiteGerenteRegional?.toLocaleLowerCase() as keyof typeof MOTIVOS], justificativa: talhaoJustificado?.justificativaAtrasoObservacaoAceiteGerenteRegional, data: talhaoJustificado?.justificativaAtrasoDataAceiteGerenteRegional, aprovado: talhaoJustificado?.status }
    );
  }

  return (
    <CustomModal
      title={`Talhão: ${talhaoJustificado?.talhao} - Operação ${talhaoJustificado?.operacao} - Data Planejada: ${formatDateBR(talhaoJustificado?.dataProgramada!)}`}
      visible={isOpenView}
      onCancel={closedModal}
      width={"80%"}
      maskClosable={false}
      centered
      getContainer={document.body}
      className="teste"
      footer={null}
    >
      <ModalContainer>
        <ModalSectionTitle icon="📝">
          Justificativa
        </ModalSectionTitle>
        <ModalTableContentWrap>
          <ContainerTable>
          <RoundedTable
              style={{ marginBottom: 16 }}
              columns={column()}
              dataSource={listTableJustificativa}
              className="my-table"
              sticky
              pagination={false}
          />
          </ContainerTable>
          </ModalTableContentWrap>
          <Content>
            <ModalSectionTitle icon="ℹ">
              Informações Adicionais
            </ModalSectionTitle>
            <TableInfo>
              <tbody>
                {
                  INFO_TABLE?.map((item, index) => (
                    <tr key={index}>
                      <InfoLabel>{item.name}</InfoLabel>
                      <InfoValue>{item.value}</InfoValue>
                    </tr>
                  ))
                }
              </tbody>
            </TableInfo>

          </Content>
          <ContainerFooter>
            <Button
            size="large"
            onClick={closedModal}
            style={{ borderRadius: 8 }}
          >Fechar</Button>
          </ContainerFooter>
        </ModalContainer>
    </CustomModal>
  );
}

const CustomModal = styled(Modal)`
  position: relative;

  /* max-height: 85vh; */

  .ant-modal-content {
    border-radius: 10px;
    height: 100%;
    
    display: flex;
    flex-direction: column;
  }

  .ant-modal-header {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: #12619C;
    height: 61px;
  }

  .ant-modal-title {
    color: #fff;
    font-weight: bold;
  }

  .ant-modal-close-x {
    color: #fff;
  }

  .ant-form-item-required::before {
      content: none !important;
    }

  .ant-form-item-required::after {
    display: inline-block !important;
    margin-left: 4px !important;
    color: red;
    font-size: 14px !important;
    line-height: 1 !important;
    content: "*" !important;
  }

  td .ant-form-item {
    margin-bottom: 0;
  }

  td .ant-form-item-with-help .ant-form-item-explain {
    display: none;
  }

  td input[type=number], td input[type=date] {
    height: 2.4rem;
  }

  .ant-modal-body {
    padding: 0;
    position: relative;

    /* max-height: calc(90vh - 30px); */
    /* height: 86vh; */
    height: auto;
    display: flex;
    flex-direction: column;
    flex: 0 0 auto;

    overflow: hidden;
  }

  .ant-modal-footer {
    /* height: 61px; */
  }

  .inner-overlay {
    position: absolute;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.45);
    z-index: 5;
    backdrop-filter: blur(2px);
  }
`;

const ContainerFooter = styled.div`
  display: flex;
  justify-content: flex-end;
`;


const ModalContainer = styled.div`
  padding: 12px 20px 12px 20px;
  display: flex;
  flex-direction: column;

  flex: 1;
  min-height: 0;
`;

const ModalSectionTitle = styled.div<{ icon: string }>`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 500;
  color: #333;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e0e0e0;

  &::before {
    font-size: 18px;
    color: #1976d2;
    content: "${({ icon }) => icon}";
  }
`;

const RoundedTable = styled(DatatableAntd)`
  .ant-table {
    border-radius: 8px;
    overflow: hidden;
  }

  .ant-table-container {
    border-radius: 8px;
    overflow: hidden;
  }

`;

const ModalTableContentWrap = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 0;
`;


const Content = styled.div`
  height: 343.23px;
`;

const TableInfo = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 8px;
  background: white;
  margin-left: auto;
  margin-right: auto;

  tr:hover {
    background: #fafafa;
  }
`;

const ContainerTable = styled.div`
 max-height: calc(90vh - 350px); 
  overflow-y: auto;

`;

const InfoTd = styled.td`
  position: relative;
  overflow: visible;
  text-align: center;
  border-bottom: 1px solid #f0f0f0;
  vertical-align: top;
  padding: 10px 12px;
  font-size: 13px;
`;

const InfoLabel = styled(InfoTd)`
  font-weight: 500;
  color: #333;
  width: 50%;
  background: #fafafa;
`;

const InfoValue = styled(InfoTd)`
  color: #666;
  width: 50%;
`;

export default ModalViewTalhaoJustificativa;